import { render, staticRenderFns } from "./step-datosPersonales.vue?vue&type=template&id=0f9919cc&"
import script from "./step-datosPersonales.vue?vue&type=script&lang=js&"
export * from "./step-datosPersonales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports